

<template>
	<div>
		<compWrapper theme="primary" title="基本信息">
			<compFormQuery
				v-if="isQuery"
				:formdata="getBase"
				:labelWidth="120"
				class="margin-layout"
				:value="formData"
			/>
			<compFormEdit
				v-else
				:formdata="getBase"
				:labelWidth="120"
				class="margin-layout"
				ref="formbase"
				v-model="formData"
			/>
			<vButtonGroup class="text-right padding-right-10">
				<vButton v-if="isQuery" @click="downloadFile" class="margin-right-10" theme="primary">下载</vButton>
				<vButton v-else @click="handleFileModal" class="margin-right-10" theme="primary">上传附件</vButton>
				<vButton @click="close">返回</vButton>
			</vButtonGroup>
		</compWrapper>
		<vLoading loading size="large" transfer v-if="loading"></vLoading>
		<!-- 弹框 -->
		<compModal @on-close="operate.show=false" v-bind="operate" v-model="operate.show">
			<component :is="operate.component" v-bind="operate" v-if="operate.component" v-on="operate.on" />
		</compModal>
	</div>
</template>

<script>
import { HttpUploadAttachmentFile, HttpAttachmentFile } from "@/service/ucadm";
import compUpload from '@components/templates/upload';
import mixin from '../mixin'
export default {
	mixins: [mixin],
	components: {
		compUpload,
	},
	data() {
		return {
			loading: false,
			type: this.$route.params.type,
			id: this.$route.query.id,
			formData: {

			},
			operate: {
				show: false,
			}
		}
	},
	created() {
		this.getDetial();
	},
	computed: {
		isQuery() {
			return this.type === 'query'
		},
		getBase() {
			return [
				{
					label: 'ID',
					key: 'id',
					show: this.isQuery,
				},
				{
					label: '所属模块',
					key: 'model',
					tag: 'vSelect',
					options: this.getAttachmentModels.map(item => { return { value: item.attach.code, label: item.label } }),
					props: {
						filterable: true,
					}
				}, {
					label: '所属类型',
					key: 'type',
					tag: 'vSelect',
					options: this.getAttachmentTypes.map(item => { return { value: item.attach.code, label: item.label } }),
					props: {
						filterable: true,
					}
				}, {
					label: '关联资源标识',
					key: 'srcLabel',
					tag: 'vInput',
				}, {
					label: '附件标题',
					key: 'title',
					tag: 'vInput',
					required: false,
				},
				{
					label: '附件批次id',
					key: 'batchId',
					tag: 'vInput',
					required: false,
				},
				{
					label: '附件说明',
					key: 'brief',
					tag: 'vTextarea',
					required: false,
				},
				{
					label: '文件名',
					key: 'filename',
					show: this.isQuery,
				},
				{
					label: '文件大小',
					key: 'fileSize',
					show: this.isQuery,
				},
				{
					label: '扩展名',
					key: 'ext',
					show: this.isQuery,
				},
				{
					label: '创建时间',
					key: 'createdAt',
					show: this.isQuery,
				},
				{
					label: '创建者',
					key: 'createdName',
					show: this.isQuery,
				},
			]
		}
	},
	methods: {
		close() {
			this.$router.push({
				name: 'attachmentfile'
			})
		},
		//获取详情
		async getDetial() {
			if (this.type !== 'query') return
			this.loading = true;
			HttpAttachmentFile({ id: this.id }).then(res => {
				const data = res.data || {};
				this.formData = data.entity;
				const typeData = this.getAttachmentTypes.find(item => item.value == this.formData.typeId);
				const modelData = this.getAttachmentModels.find(item => item.value == this.formData.modelId);
				this.formData.type = typeData ? typeData.attach.code : '';
				this.formData.model = modelData ? modelData.attach.code : '';
				this.loading = false
			}).catch(err => {
				this.$VMessage.error(err.message)
				this.loading = false
			})
		},
		async handleFileModal() {
			const valid = await this.$refs.formbase.validate();
			if (!valid) return;
			console.log(this.formData)
			this.operate = {
				title: '上传附件',
				show: true,
				width: 460,
				component: "compUpload",
				name: "multipartFile",
				ajaxRequest: HttpUploadAttachmentFile,
				data: this.formData,
				on: {
					'on-success': this.close,
				},
				showFooter: false,
			}
		},
		// 下载
		downloadFile() {
			this.handleWebfs(this.formData.genUrl, {}, { executor: 'download', type: 'url' })
		},

	}
}
</script>
